export const LoginFixture = {
  statusCode: 200,
  token: "iPdBeZscDCCSHUYS3Pxsq7N11IBHpgbytUJeAAaA=",
  segment: "RESI",
};
